import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TablePagination from "@mui/material/TablePagination";
import Button from "@mui/material/Button";
import PreviewIcon from "@mui/icons-material/Preview";
import Toolbar from "@mui/material/Toolbar";
import { Link, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "@mui/material/styles";
import {
  TextField,
  Autocomplete,
  Modal,
  useMediaQuery,
  Grid,
  Box,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";
import "../../utils/helper/helper.css";
import { masterDatasheetTemplateListGuide } from "./guide";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import ListWrap from "../../utils/commonComponent/listWrap";

const columns = [
  { id: "id", label: "Sr. No.", minWidth: 20 },
  { id: "MaterialName", label: "Material Name", minWidth: 40 },
  { id: "testName", label: "Test Name", minWidth: 40 },
];

function createData(id, MaterialName, testName) {
  return {
    id,
    MaterialName,
    testName,
  };
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  width: "50% !important",
  height: "40% !important",
};

export default function DatasheetTemplateList(props) {
  const masterDatasheetTemplateListGuides = masterDatasheetTemplateListGuide();
  const isMobile = useMediaQuery("(max-width: 600px)");
  const location = useLocation();
  const [userData, setUserData] = React.useState([]);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "label");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));  

  const [totalRecords, setTotalRecords] = React.useState(0);
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [editAccess, setEditAccess] = React.useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );
  const [open, setOpen] = React.useState(false);
  const [materialScopeArray, setMaterialScopeArray] = React.useState([]);
  const [materialTestingsArray, setMaterialTestingsArray] = useState([]);
  const [testId, setTestId] = useState(null);
  const [materialId, setMaterialId] = useState(null);
  const [selectedInstrument, setSelectedInstrument] = React.useState(null);
  const [copyDatasheetTemplate, setCopyDatasheetTemplate] = React.useState([]);

  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const handleClose = () => setOpen(false);

  const handleOpen = (row) => {
    // setTableName(row.tableName);
    let url = BASE_URL;
    axiosWithToken
      .get(url + `datasheetTemplate?_where=(id,eq,${row.id})`)
      .then((res) => {
        setCopyDatasheetTemplate(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });

    setOpen(true);
  };

  const getMaterialScopeList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "materialScope?_where=(status,eq,1)")
      .then((res) => {
        setMaterialScopeArray(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getMaterialTestingsList = async () => {
    try {
      const sqlQuery = {
        query: `SELECT id, testName, materialId FROM materialTestings WHERE status = 1 AND materialId = ${materialId}`,
      };
      const res = await axiosWithToken.post(`${BASE_URL}dynamic`, sqlQuery);
      setMaterialTestingsArray(res.data || []);
    } catch (error) {
      if (error.message !== "request_aborted") {
        toast.error("Something went wrong! Error code: 5");
      }
    }
  };

  const handleSubmit = () => {
    // props.setLoader(true);
    let url = BASE_URL;
    const { id, lastModified, status, ...rest } = copyDatasheetTemplate[0];
    const data = {
      ...rest,
      materialId: materialId,
      testId: testId,
    };

    axiosWithToken
      .post(url + `datasheetTemplate`, data)
      .then((res) => {
        toast("Datasheet Template is copied!");
        // props.setLoader(false);
        setTimeout(refresh, 500);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
        // props.setLoader(false);
      });
  };

  const submitSiteDelete = (id) => {
    // props.setLoader(true);
    let url = BASE_URL;
    axiosWithToken
      .delete(url + `datasheetTemplate/${id}`)
      .then((res) => {
        toast("Datasheet Template is deleted!");
        // props.setLoader(false);
        setTimeout(refresh, 500);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
        // props.setLoader(false);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const getDatasheetTemplateList = async () => {
    try {
      const colMap = { "Material Name": "ms.MaterialName" };
      const colName = colMap[searchBy];
      const key = searchKey.trim();

      const whereConditions = [];
      if (colName && key) whereConditions.push(`${colName} LIKE '%${key}%'`);

      const whereClause = whereConditions.length
        ? `WHERE ${whereConditions.join(" AND ")}`
        : "";
      const limit =
        rowsPerPage !== -1
          ? `LIMIT ${rowsPerPage} OFFSET ${currentPage * rowsPerPage}`
          : "";

      const query = `SELECT dt.*, ms.MaterialName, mt.testName FROM datasheetTemplate AS dt LEFT JOIN materialScope AS ms ON dt.materialId = ms.id LEFT JOIN materialTestings AS mt ON dt.testId = mt.id ${whereClause} ORDER BY dt.id DESC ${limit};`;

      const { data: templates = [] } = await axiosWithToken.post(
        `${BASE_URL}dynamic`,
        { query }
      );

      const rowData = templates.map((t) =>
        createData(t.id, t.MaterialName, t.testName)
      );

      setUserData(rowData);
    } catch (err) {
      console.error("Datasheet template fetching error:", err);
    }
  };

  // api calls
  const getTotalRows = async () => {
    try {
      const colMap = { "Material Name": "ms.MaterialName" };
      const colName = colMap[searchBy];
      const key = searchKey.trim();

      const whereConditions = [];
      if (colName && key) whereConditions.push(`${colName} LIKE '%${key}%'`);

      const whereClause = whereConditions.length
        ? `WHERE ${whereConditions.join(" AND ")}`
        : "";

      const query = `SELECT COUNT(*) AS no_of_rows FROM datasheetTemplate AS dt LEFT JOIN materialScope AS ms ON dt.materialId = ms.id LEFT JOIN materialTestings AS mt ON dt.testId = mt.id ${whereClause};`;

      const { data } = await axiosWithToken.post(`${BASE_URL}dynamic`, {
        query,
      });

      setTotalRecords(data?.[0]?.no_of_rows || 0);
    } catch (err) {
      console.error("Datasheet total rows fetching error:", err);
    }
  };

  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if (storedSearchBy) {
      setSearched(true);
    }
  }, [storedSearchBy]);

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    setSearched(true);
    getMaterialScopeList();
    getDatasheetTemplateList();
    getTotalRows();
    setCurrentPage(0);
  };
  const clearSearch = () => {
    setSearched(false);
    setSearchBy("Material Name");
    setSearchKey("");
    setCurrentPage(0);
     // Clear all cert list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
  };

  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  useEffect(() => {
    getDatasheetTemplateList();
    getTotalRows();
  }, [rowsPerPage, currentPage]);

  useEffect(() => {
    if (materialId) getMaterialTestingsList();
  }, [materialId]);

  useEffect(() => {
    if (searched == false) {
      getDatasheetTemplateList();
      getMaterialScopeList();
      getTotalRows();
    }
    if (searched) {
      setCurrentPage(0);
    }
  }, [searched]);

  const filterSection = () => (
    <Grid
      container
      spacing={2}
      // justifyContent="flex-end"
      alignItems="center"
      style={{ padding: "5px 0px", marginBottom: "2px" }}
    >
      <Grid item xs={12} sm={5} md={2} lg={2}>
        <Autocomplete
          sx={{
            m: 0,
            minWidth: 180,
          }}
          size="small"
          className="Listinputcss"
          value={searchBy}
          id="template_master_list_searchby"
          options={[{ key: "MaterialName", label: "Material Name" }]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            setSearchBy(newInputValue);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={2}>
        <TextField
          id="template_master_list_searchbytext"
          label={"enter " + searchBy}
          size="small"
          className="Listinputcss"
          variant="outlined"
          value={searchKey}
          inputProps={{
            autoComplete: "off",
          }}
          onChange={(e) => {
            setSearchKey(e.target.value);
            setSearched(false);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={2} lg={1}>
        <Button
          id="template_master_list_searchbtn"
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : handleSearch();
          }}
        >
          {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Grid>
    </Grid>
  );

  const filterModal = () => {
    return (
      <Modal open={filterModalOpen} size="md">
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 30%)",
            backgroundColor: "white",
            // border: "2px solid #000",
            boxShadow: 24,
            padding: "10px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ float: "right" }}
            onClick={handleFilterClose}
          >
            X
          </Button>
          {filterSection()}
        </Box>
      </Modal>
    );
  };

  return (
    <ListWrap>
      {filterModal()}
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <br />
            <div className="flex flex-wrap gap-4 mb-6">
              <div className="w-full">
                <Autocomplete
                  size="small"
                  id="combo-box-demo"
                  // value={materialId + ", " + materialName}
                  options={materialScopeArray.map((instrument) => {
                    return {
                      label: instrument.id + ", " + instrument.MaterialName,
                    };
                  })}
                  onChange={(event, value) => {
                    if (value) {
                      setMaterialId(parseInt(value.label.split(",")[0]));
                      // setMaterialName(value.label.split(",")[1]);
                      // fetchUncertaintyFactors(value.label.split(",")[0]);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Material"
                      className="w-full"
                    />
                  )}
                />
              </div>

              <div className="w-full sm:w-1/2 md:w-1/2 lg:w-1/2">
                <Autocomplete
                  id="testings"
                  size="small"
                  options={materialTestingsArray}
                  value={
                    materialTestingsArray.find((opt) => opt.id == testId) ||
                    null
                  }
                  getOptionLabel={(option) => option?.testName || ""}
                  onChange={(_, value) => setTestId(value ? value.id : null)}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Testings"
                      className="w-full"
                    />
                  )}
                />
              </div>
            </div>
            <br />
            <Toolbar style={{ padding: "0px", overflow: "auto" }}>
              <Button
                variant="contained"
                size="small"
                sx={{ m: 0 }}
                onClick={() => {
                  handleSubmit();
                }}
              >
                Save
              </Button>
            </Toolbar>
          </Box>
        </Modal>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
          <Button
            id="datasheet_template_list_createbtn"
            variant="contained"
            size="small"
            component={Link}
            to="/master/createDatasheetTemplate"
          >
            <b>create TEMPLATE</b>
          </Button>
        </Toolbar>
        <Box sx={{ display: "flex", gap: "0rem" }}>
          <Button
            style={{ display: isMobile ? "block" : "none" }}
            onClick={handleFilterOpen}
          >
            <FilterAltIcon />
          </Button>
          <Tooltip title="User Guide" placement="top-start">
            <Button
              onClick={() => {
                masterDatasheetTemplateListGuides.drive();
              }}
            >
              <HelpIcon />
            </Button>
          </Tooltip>
        </Box>
      </div>

      {!isMobile && filterSection()}
      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.id}
                    className="px-4 py-3 text-center whitespace-nowrap capitalize"
                  >
                    {column.label}
                  </th>
                ))}
                <th className="px-4 py-3 text-center">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {userData?.length > 0 ? (
                userData.map((row, index) => (
                  <tr
                    key={row.id}
                    className="hover:bg-gray-50 transition-colors border-b border-gray-200"
                  >
                    {columns.map((column) => {
                      let value = row[column.id];
                      if (column.id === "id") {
                        value = currentPage * rowsPerPage + (index + 1);
                      }

                      return (
                        <td
                          key={column.id}
                          className="px-4 py-3 text-center whitespace-nowrap capitalize"
                        >
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </td>
                      );
                    })}

                      <td className="px-4 py-2 text-center">
                      <div className="flex items-center justify-center gap-2">
                        <Tooltip
                          title="Edit Datasheet Template"
                          placement="top-start"
                        >
                          <Button
                            id="datasheet_template_list_edit"
                            component={Link}
                            to={`/master/editDatasheetTemplate/${row.id}`}
                            size="small"
                            disableRipple
                            disableElevation
                            className="!min-w-0 !p-0 !m-0 !rounded-none"
                          >
                            <PreviewIcon fontSize="medium" />
                          </Button>
                        </Tooltip>

                        {/* Copy Button */}
                        <Tooltip title="Copy Template" placement="top-start">
                          <span id="template_master_list_copy">
                            <Button
                              id={row.id}
                              key={row.id}
                              disabled={
                                !(
                                  editAccess?.includes(5) ||
                                  editAccess?.includes(0)
                                )
                              }
                              onClick={() => handleOpen(row)}
                              size="small"
                              disableRipple
                              disableElevation
                              className="!min-w-0 !p-0 !m-0 !rounded-none"
                            >
                              <ContentCopyIcon fontSize="medium" />
                            </Button>
                          </span>
                        </Tooltip>

                        {/* Delete Button */}
                        <Tooltip
                          title="Delete Datasheet Template"
                          placement="top-start"
                        >
                          <Button
                            id="datasheet_template_list_delete"
                            size="small"
                            disabled={
                              !(
                                editAccess?.includes(2) ||
                                editAccess?.includes(0)
                              )
                            }
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Really want to delete Datasheet Template?"
                                )
                              ) {
                                submitSiteDelete(row.id);
                              }
                            }}
                            disableRipple
                            disableElevation
                            className="!min-w-0 !p-0 !m-0 !rounded-none"
                          >
                            <DeleteIcon
                              fontSize="medium"
                              style={{
                                color: !(
                                  editAccess?.includes(2) ||
                                  editAccess?.includes(0)
                                )
                                  ? "lightgray"
                                  : "#dc3545",
                              }}
                            />
                          </Button>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={columns.length + 1}
                    className="text-center p-4 font-semibold text-gray-600"
                  >
                    Data Not Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between gap-2 px-2 py-2 bg-blue-50 text-xs sm:text-sm border-t overflow-x-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <span>Rows Per Page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-1 py-0.5 text-xs sm:text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-gray-600 hidden sm:inline">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                    (currentPage + 1) * rowsPerPage,
                    totalRecords
                  )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </ListWrap>
  );
}